<app-solution-page [config]="pageConfig"></app-solution-page>
